var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',[_c('b-col',{staticClass:"d-flex vh-100 flex-column justify-content-center align-items-center"},[_c('feather',{staticStyle:{"height":"80px","width":"80px"},attrs:{"type":"meh","size":"80"}}),_c('h4',{staticClass:"mt-4"},[_vm._v("Sorry, nothing here")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }